module.exports = __webpack_public_path__ + "img/516c0b7.jpg";